export default "__VITE_ASSET__avq78VBx__"